<!-- Por debajo de $md se oculta todo .ps-body y solo queda la cabecera con nombre y correo (ver
     el media query del scss). -->
<aside class="profile-sidebar">
    <div class="ps-header">
        <h2>{{ userFullName || 'Mi cuenta' }}</h2>
        <p *ngIf="userEmail">{{ userEmail }}</p>
    </div>

    <div class="ps-body">

        <section class="ps-section">
            <h3>MI CUENTA</h3>
            <a class="ps-item" [class.active]="active === 'profile'" (click)="select('profile')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <circle cx="12" cy="8" r="4" stroke-linejoin="round"/>
                        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="ps-label">Perfil</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
            <a class="ps-item" [class.active]="active === 'change-password'" (click)="select('change-password')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <rect x="5" y="11" width="14" height="10" rx="2"/>
                        <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke-linecap="round"/>
                    </svg>
                </span>
                <span class="ps-label">Cambiar contraseña</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
            <a *ngIf="showDirectAreas" class="ps-item" [class.active]="active === 'bank'" (click)="select('bank')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <rect x="5" y="11" width="14" height="10" rx="2"/>
                        <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke-linecap="round"/>
                    </svg>
                </span>
                <span class="ps-label">Domiciliaciones</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
        </section>

        <section class="ps-section" *ngIf="showDirectAreas || hasLegalAssistanceProduct">
            <h3>GESTIONES</h3>
            <a *ngIf="showDirectAreas" class="ps-item" [class.active]="active === 'receipts'" (click)="select('receipts')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <rect x="3" y="6" width="18" height="12" rx="2"/>
                        <circle cx="12" cy="12" r="2"/>
                    </svg>
                </span>
                <span class="ps-label">Mis recibos</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
            <a *ngIf="hasLegalAssistanceProduct" class="ps-item" [class.active]="active === 'insured'" (click)="select('insured')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <circle cx="12" cy="8" r="4"/>
                        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="ps-label">Mis asegurados</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
        </section>

        <section class="ps-section" *ngIf="showDirectAreas">
            <h3>PREFERENCIAS</h3>
            <a *ngIf="showDirectAreas" class="ps-item" [class.active]="active === 'notifications'" (click)="select('notifications')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2H4.5L6 16z" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 20a2 2 0 0 0 4 0" stroke-linecap="round"/>
                    </svg>
                </span>
                <span class="ps-label">Notificaciones</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
            <a *ngIf="showDirectAreas && isTaker" class="ps-item" [class.active]="active === 'consent'" (click)="select('consent')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <rect x="3" y="5" width="18" height="14" rx="2"/>
                        <path d="M3 7l9 6 9-6" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="ps-label">Consentimiento</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
        </section>

        <section class="ps-section" *ngIf="showDirectAreas">
            <h3>AYUDA</h3>
            <a class="ps-item" [class.active]="active === 'help'" (click)="select('help')">
                <span class="ps-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                        <path d="M4 12a8 8 0 0 1 16 0v3a3 3 0 0 1-3 3h-1v-6h4M4 12v3a3 3 0 0 0 3 3h1v-6H4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>
                <span class="ps-label">Atención al cliente</span>
                <span class="ps-chevron">&#x203A;</span>
            </a>
        </section>

        <a class="ps-item ps-logout" (click)="logout()">
            <span class="ps-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
                    <path d="M10 17l-5-5 5-5M5 12h12M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
            <span class="ps-label">Cerrar sesión</span>
        </a>

    </div>
</aside>
